<template>
<div class="page">
    <div class="tabs mb-5">
        <div class="tabs-header">
            <div
                :class="['tabs-header-item', { active: active_tab === 'setup-tenants'}]"
                @click="active_tab = 'setup-tenants'">
                Setup Tenants
            </div>

            <div
                :class="['tabs-header-item', { active: active_tab === 'list-tenants'}]"
                @click="active_tab = 'list-tenants'">
                List Setup Tenants
            </div>
        </div>

        <div class="tabs-content">
            <div v-if="active_tab === 'setup-tenants'">
                <SetupTenantsTab />
            </div>

            <div v-else-if="active_tab === 'list-tenants'">
                <ListTenantsTab />
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ListTenantsTab from "../components/insurance-policy-management-page/ListTenantsTab"
import SetupTenantsTab from "../components/insurance-policy-management-page/SetupTenantsTab"

export default {
    name: "insurance-policy-management-page",

    components: {
        ListTenantsTab,
        SetupTenantsTab
    },

    data () {
        return {
            active_facility_index: 0,
            active_tab: "setup-tenants",
            facilities: []
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/InsurancePolicyManagementPage.vue